import React from "react";
import { useParams } from "react-router-dom";
import Login from "../views/LoginView";
import Projects from "../views/ProjectsView";
import Account from "../views/AccountView";
import Data from "../views/DataView";
import ResetPassword from "../views/ResetPasswordView";
import Member from "../views/MemberView";
import EditProject from "../views/EditProjectView";
import { decrypt } from "../utils/cryptoHelper";
import { INTERNAL_ONLY } from "../api";
import { internalUsernames } from "../api/user";
import VerifyEmail from "../views/VerifyEmailView";

const ModuleController = () => {
  const { moduleName } = useParams();

  // allow external users to access email verification
  if (moduleName === "verifyEmail") {
    return <VerifyEmail />;
  }

  if (INTERNAL_ONLY) {
    const token = window.localStorage.getItem("token");
    if (token != null) {
      const user = JSON.parse(decrypt(token));
      if (
        user.username != null &&
        !internalUsernames.includes(user.username.toLowerCase())
      ) {
        return <Login />;
      }
    }
  }

  switch (moduleName) {
    case "projects":
      return <Projects />;
    case "information":
      return <EditProject />;
    case "data":
      return <Data />;
    case "account":
      return <Account />;
    case "organization-management":
      return <Member />;
    case "reset-password":
      return <ResetPassword />;
    case "create-project":
      return <EditProject />;
    case "verifyEmail":
      return <VerifyEmail />;
    default:
      return <Login />;
  }
};

export default ModuleController;
